import React from "react";

const DataVisualizationdoc = () => {
  return (
    <div className='container'>
        <h1 className='text-light text-center'>Data Visualizations</h1>

      <p className='text-light'>
        Data visualization is an important aspect of the machine learning
        process, as it helps users understand and interpret the results of their
        models. The MLGUI Web Tool provides a variety of visualization options
        to help users understand their data and the performance of their models.
        These options include:
        <li>
          {" "}
          <strong>Exploration:</strong> Creating visualizations of the data to
          help users understand the distribution and patterns within the data.
        </li>
        <br />
        <li>
          <strong>Evaluation:</strong> Creating visualizations of the model's
          performance, such as accuracy, precision, and recall, to help users
          evaluate the model's performance.
        </li>
        <br />
        <li>
          <strong> Comparison:</strong> Creating visualizations to compare the
          performance of different models to help users choose the best one for
          their data.
        </li>
        <br />
        These visualization features are designed to be user-friendly and easy
        to use, even for users with no prior experience in data visualization.
        It allows students and developers to easily understand their data and
        models, which can help them make better decisions and improve the
        performance of their models.
      </p>
    </div>
  );
};

export default DataVisualizationdoc;
